import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {message} from 'antd';
import {AxiosError, AxiosResponse} from 'axios';
import FILTERS from '../../common/filters.type';
import {MAIN_FILTER, SWAP_DATA, SWAP_DETAIL} from './swap.types';
import swapServices from './swapServices';

const initialState = {
  isLoading: false,
  swapList: {
    page_size: 10,
    page_number: 1,
    sort_by: 'id',
    ascending: false,
    search: '',
    totalDataCount: 0,
    pageData: [] as SWAP_DATA[],
  },
  swapDetail: {} as SWAP_DETAIL,
};

export const swapList = createAsyncThunk(
  'swapList',
  async (payload: {body?: MAIN_FILTER; filters?: FILTERS}, thunkAPI) => {
    try {
      const data: AxiosResponse = await swapServices.swapList(payload);
      return data;
    } catch (error) {
      const result = error as AxiosError;
      return thunkAPI.rejectWithValue(result.message);
    }
  },
);

export const swapDetail = createAsyncThunk('swapDetail', async (id: number, thunkAPI) => {
  try {
    const data: AxiosResponse = await swapServices.swapDetail(id);
    return data;
  } catch (error) {
    const result = error as AxiosError;
    return thunkAPI.rejectWithValue(result.message);
  }
});

export const swapSlice = createSlice({
  name: 'swapSlice',
  initialState,
  reducers: {
    pageNumberChange(state, action: PayloadAction<number>) {
      state.swapList.page_number = action.payload;
    },
    pageSizeChange(state, action: PayloadAction<number>) {
      state.swapList.page_number = 1;
      state.swapList.page_size = action.payload;
    },
    searchBy(state, action: PayloadAction<string>) {
      state.swapList.page_number = 1;
      state.swapList.search = action.payload;
    },
    sortBy(state, action: PayloadAction<{ascending: boolean; sortBy: string}>) {
      state.swapList.ascending = action.payload.ascending;
      state.swapList.sort_by = action.payload.sortBy;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(swapList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(swapList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.swapList = action.payload.data;
    });
    builder.addCase(swapList.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });

    builder.addCase(swapDetail.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(swapDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.swapDetail = action.payload.data;
    });
    builder.addCase(swapDetail.rejected, (state, action) => {
      state.isLoading = false;
      message.error(`${action.payload}`);
    });
  },
});
export const {pageNumberChange, pageSizeChange, searchBy, sortBy} = swapSlice.actions;

export default swapSlice.reducer;
